import { Money } from '@ap/interface-bspc-core';
import { ClosingCost, ClosingCostDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class ClosingCostBuilder {
    private amount: Money;
    private detail: ClosingCostDetail;

    withAmount(amount: Money) {
        this.amount = amount;
        return this;
    }

    withDetail(detail: ClosingCostDetail) {
        this.detail = detail;
        return this;
    }

    build(): ClosingCost {
        return {
            amount: this.amount,
            detail: this.detail
        } as ClosingCost;
    }
}

export const aClosingCost = new ClosingCostBuilder();
